// :cow: Cosmose CONFIDENTIAL :iso:
import { ErrorHandler } from '@angular/core';

export class DevErrorHandler implements ErrorHandler {
  handleError(error: any): void {
    console.error(error);
  }
}
